module.exports = "<div class=\"text-center ui-grid-cell-contents\"> <a class=form_sub_head_action ng-if=row.entity.Asignatura ng-click=grid.appScope.perfildocenteVM.showModal(row.entity)> Detalle </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/perfil_docente/dialogbutton.html
// module id = 398
// module chunks = 0